module.exports = __webpack_public_path__ + "dark_wood.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/calendar/img/dark_wood.png
// module id = 790
// module chunks = 1